import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlCapTableFieldsFragment = { id: string, displayName: string, recordDate?: string | null, pricePerShare?: string | null, unregisteredShares?: string | null, currentShareCount: string, createdAt: string, updatedAt: string, companyId: string, dirty: boolean, fullyDiluted: boolean };

export const CapTableFieldsFragmentDoc = gql`
    fragment CapTableFields on CapTable {
  id
  displayName
  recordDate
  pricePerShare
  unregisteredShares
  currentShareCount
  createdAt
  updatedAt
  companyId
  dirty
  fullyDiluted
}
    `;